export default __webpack_public_path__ + "static/media/loadingLoof.7975380e.gif";